import script from "./HomePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomePage.vue?vue&type=script&lang=ts&setup=true"

import "./HomePage.vue?vue&type=style&index=0&id=60aeeb4c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/2024-mcdo-gamecenter-wrapper/2024-mcdo-gamecenter-wrapper/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60aeeb4c"]])

export default __exports__